/** http(s) links in text a person wrote. Trailing punctuation belongs to the sentence, not the link. */
const URL_RE = /https?:\/\/[^\s<>"'`]+/g
const TRAILING = /[.,;:!?)\]}'"]+$/

/** `rawEnd` is where the unbroken run of non-space text ends; the link is finished once something (a space) follows it. */
export type LinkMatch = { url: string; start: number; end: number; rawEnd: number }

export function findLinks(text: string): LinkMatch[] {
  const out: LinkMatch[] = []
  for (const m of text.matchAll(URL_RE)) {
    const url = m[0].replace(TRAILING, '')
    if (!isUrl(url)) continue
    out.push({ url, start: m.index, end: m.index + url.length, rawEnd: m.index + m[0].length })
  }
  return out
}

function isUrl(s: string): boolean {
  try { return !!new URL(s).hostname } catch { return false }
}

/** `github.com/org/repo/pull/12` rather than the whole thing; long ones end in an ellipsis. */
export function shortLink(url: string, max = 32): string {
  try {
    const u = new URL(url)
    const host = u.hostname.replace(/^www\./, '')
    const rest = (u.pathname === '/' ? '' : u.pathname.replace(/\/$/, '')) + (u.search || u.hash ? '…' : '')
    const s = host + rest
    return s.length > max ? `${s.slice(0, max - 1)}…` : s
  } catch { return url.length > max ? `${url.slice(0, max - 1)}…` : url }
}

export function linkHost(url: string): string {
  try { return new URL(url).hostname.replace(/^www\./, '') } catch { return url }
}
